<template>
  <v-dialog :value="value" max-width="640" persistent @input="$emit('input', $event)">
    <v-card class="ui-card">
      <div class="ui-card__header">
        <div>
          <h3 class="ui-section-title">Excluir credenciamento</h3>
          <p class="ui-section-description">A exclusão é lógica e o motivo fica registrado para o credor.</p>
        </div>
        <v-btn icon small :disabled="loading" @click="close"><v-icon small>mdi-close</v-icon></v-btn>
      </div>

      <div v-if="item" class="ui-card__body">
        <p class="mb-3">
          Deseja excluir o credenciamento de <strong>{{ creditorName }}</strong>
          <template v-if="meetingName"> na assembleia <strong>{{ meetingName }}</strong></template>?
        </p>

        <v-alert type="info" text dense class="mb-3">
          Nenhum e-mail é enviado. A mensagem abaixo fica registrada no cadastro do credor e aparece para ele no site,
          na área de credenciamentos, como um comunicado da Administração Judicial.
        </v-alert>

        <v-progress-linear v-if="checking" indeterminate class="mb-3" />
        <v-alert v-else-if="preview && !preview.can_delete" type="error" text dense class="mb-3">
          Este credenciamento possui votos, presenças ou substabelecimentos e não pode ser excluído.
        </v-alert>

        <p class="ui-label">Motivo da exclusão</p>
        <tiptap-vuetify
          v-model="reason"
          :extensions="extensions"
          :disabled="loading"
          placeholder="Descreva o motivo da exclusão"
          class="deletion-editor"
        />
      </div>

      <div class="ui-card__footer">
        <v-btn outlined :disabled="loading" @click="close">Cancelar</v-btn>
        <v-btn v-if="$allowed('acc.purge')" color="error" depressed :loading="loading" :disabled="!canConfirm" @click="confirm">
          Confirmar exclusão
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";
import { TiptapVuetify, Bold, Italic, Underline, Paragraph, BulletList, OrderedList, ListItem, HardBreak, History } from "tiptap-vuetify";

// Exclusao logica de um credenciamento a partir da lista, com motivo em editor
// rico. Reaproveita a previa e a remocao administrativa ja existentes na API.
export default {
  name: "AccreditationDeleteDialog",

  components: { "tiptap-vuetify": TiptapVuetify },

  props: {
    value: { type: Boolean, default: false },
    // Linha do credenciamento (accreditation_general_meetings), com accreditation.user e generalMeeting.
    item: { type: Object, default: null },
  },

  data: () => ({
    loading: false,
    checking: false,
    preview: null,
    reason: "",
    extensions: [History, Bold, Italic, Underline, ListItem, BulletList, OrderedList, Paragraph, HardBreak],
  }),

  computed: {
    creditorName() {
      const user = this.item && this.item.accreditation && this.item.accreditation.user;
      return (user && user.name) || (this.item && this.item.creditor_name) || "este credor";
    },

    meetingName() {
      const meeting = this.item && (this.item.generalMeeting || this.item.general_meeting);
      return meeting && meeting.name ? meeting.name : "";
    },

    reasonText() {
      return String(this.reason || "").replace(/<[^>]*>/g, "").replace(/&nbsp;/g, " ").trim();
    },

    canConfirm() {
      return !this.checking && !!this.preview && !!this.preview.can_delete && this.reasonText.length >= 5;
    },
  },

  watch: {
    value(open) {
      if (open) this.prepare();
    },
  },

  methods: {
    async prepare() {
      this.reason = "";
      this.preview = null;
      if (!this.item || !this.item.id) return;

      this.checking = true;
      try {
        const result = await axios.post("/api/admin/accreditations/deletion-preview", { ids: [this.item.id] });
        this.preview = result.data.content;
      } catch (error) {
        this.$dialog.notify.error(this.$codes(error), { position: "top-right", timeout: 4000 });
        this.preview = { can_delete: false };
      } finally {
        this.checking = false;
      }
    },

    close() {
      if (this.loading) return;
      this.$emit("input", false);
    },

    async confirm() {
      if (!this.canConfirm) return;

      this.loading = true;
      try {
        await axios.post("/api/admin/accreditations/delete-test-records", {
          ids: [this.item.id],
          reason: this.reason,
        });
        this.$dialog.notify.success("Credenciamento excluído.", { position: "top-right", timeout: 3000 });
        this.$emit("deleted", this.item);
        this.$emit("input", false);
      } catch (error) {
        this.$dialog.notify.error(this.$codes(error), { position: "top-right", timeout: 5000 });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.deletion-editor >>> .ProseMirror {
  min-height: 140px;
}
</style>
